import { useState } from "react"
import { externalLogin } from "../../services/HipService";

export const useIdentity = () => {
  const [identity, setIdentity] = useState();

  const fetchIdentity = async (idToken) => {
    const res = await externalLogin(idToken);
    setIdentity(res);
  }

  const getIdentity = () => {
    return identity;
  }

  return {
    getIdentity,
    fetchIdentity
  }
}